import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { periodoSemiaberto } from "../pages/general/homeV2Helpers";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export const rscorePorFilial = (resposta) => {
  const mapa = {};
  (resposta?.branches || []).forEach((filial) => {
    mapa[filial.branch_id] = filial;
  });
  return mapa;
};

export default function useRScoreV2({
  branchIds,
  startDate,
  endDate,
  enabled = true,
}) {
  const { getRScoreMetrics } = useApiV2();
  const { user } = useAuth();
  const { start, end } = periodoSemiaberto([startDate, endDate]);
  const ids = useMemo(
    () => [...new Set((branchIds || []).filter(Boolean))].sort((a, b) => a - b),
    [branchIds]
  );
  const params = { branch_id: ids, start, end, tipo: "total" };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["rscoreV2", user?.user_id ?? null, params],
    queryFn: () => getRScoreMetrics(params),
    enabled: Boolean(enabled && ids.length && start && end),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });

  const porFilial = useMemo(() => rscorePorFilial(data), [data]);
  return { porFilial, isLoading, isError, error };
}
